<template>
  <!-- 최적화브라우저 -->
  <div class="noti_browser" v-if="opendWebOptimumAlarm">
    <em class="noti_txt" v-html="$t('gnb.optimum-msg')"></em>
    <span class="inp_check_wrap">
      <input type="checkbox" id="check_notshow_again" class="inp_check" @click="close">
      <label for="check_notshow_again" class="lb_txt">{{ $t('common.dont-show-again') }}</label>
    </span>
    <button type="button" class="btn_close_noti" @click="close">{{ $t('common.button.close') }}</button>
  </div>
  <!-- //최적화브라우저 -->
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { types as commonTypes, namespace as commonNamespace } from '../../store/modules/common-store'

export default {
  created() {
    this.setWebOptimumAlarm(this.isChrome() == false && localStorage.hideWebOptimumAlarm == null)
  },
  computed: {
    ...mapState(commonNamespace, ['opendWebOptimumAlarm'])
  },
  methods: {
    ...mapMutations(commonNamespace, [commonTypes.SET_WEB_OPTIMUM_ALARM]),
    isChrome() {
      return (/Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)) || /CriOS/.test(navigator.userAgent)
    },
    close() {
      localStorage.hideWebOptimumAlarm = true
      this.setWebOptimumAlarm(false)
    }
  }
}
</script>
